import React from 'react';
import { Box, Button, Paper, Stack, Text, Title } from '@mantine/core';
import CompanyLogo from '../../components/branding/CompanyLogo';
import { isSchedulerLoggedOut } from '../../auth/schedulerSession';
import { redirectToPortal, resolvePortalRedirectUrl } from '../../utils/logout';

/**
 * Shown when there is no active scheduler session — avoids silently re-using Portal2 cookies.
 */
const PortalLandingPage: React.FC = () => {
  const loggedOut = isSchedulerLoggedOut();

  const returnUrl = resolvePortalRedirectUrl();
  const canOpenPortal = !!returnUrl;

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 24,
        backgroundColor: 'var(--app-shell-bg, var(--mantine-color-gray-1))',
      }}
    >
      <Paper shadow="md" p="xl" radius="md" style={{ maxWidth: 520, width: '100%' }}>
        <Stack gap="lg" align="center">
          <CompanyLogo height={16} />

          <Stack gap="xs" align="center">
            <Title order={2} size="h3" ta="center">
              {loggedOut ? 'Signed out of the scheduler' : 'Sign in to continue'}
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              {loggedOut
                ? 'Your scheduler session was cleared. Open Portal2 to continue.'
                : 'This app uses your Portal2 login. Open it from the main portal — do not rely on a cached browser tab.'}
            </Text>
          </Stack>

          <Stack gap="sm" w="100%">
            <Button
              fullWidth
              size="md"
              disabled={!canOpenPortal}
              onClick={() => redirectToPortal(returnUrl)}
            >
              Login
            </Button>
          </Stack>

          {!canOpenPortal ? (
            <Text size="xs" c="dimmed" ta="center">
              No portal link was found. Set VITE_MAIN_PORTAL_BASEURL or open the scheduler from
              Portal2.
            </Text>
          ) : null}
        </Stack>
      </Paper>
    </Box>
  );
};

export default PortalLandingPage;
